import type { ItemCommitErrorOptions } from "./item-commit-error.exception";

export class ItemWriteError extends Error {
  constructor(public readonly options: ItemCommitErrorOptions) {
    super(options.message);
  }
}
